import { InputMask, InputMaskProps } from '@react-input/mask';
import * as React from 'react';
import InputWithIcon, { InputWithIconProps } from '../InputWithIcon';

export interface Props
  extends Pick<
      InputMaskProps,
      | 'mask'
      | 'replacement'
      | 'track'
      | 'modify'
      | 'showMask'
      | 'separate'
      | 'component'
    >,
    InputWithIconProps {}

const MaskedInput = React.forwardRef<HTMLInputElement, Props>((props, ref) => {
  return <InputMask component={InputWithIcon} ref={ref} {...props} />;
});

export default MaskedInput;
